import request from '@/api/request'

export function listPolygonalFence () {
  return request({
    url: 'webapi/polygonalFence/list',
    method: 'get'
  })
}

export function getFenceByLifeguard (data) {
  const req = {
    userId: data
  }
  return request({
    url: 'webapi/polygonalFence/getFenceByLifeguard',
    method: 'post',
    data: req
  })
}

export function insertPolygonalFence (data) {
  const req = {
    deviceImei: data.deviceImei,
    fenceName: data.fenceName,
    inOut: data.inOut,
    userId: data.userId,
    pointList: data.pointList
  }
  return request({
    url: 'webapi/polygonalFence/insertPolygonalFence',
    method: 'post',
    data: req
  })
}

export function deletePolygonalFence (data) {
  const req = {
    fenceId: data.fenceId
  }
  return request({
    url: 'webapi/polygonalFence/deletePolygonalFence',
    method: 'post',
    data: req
  })
}
